'use client';

import type React from 'react';

// @google/genai FIX: Updated component to accept and spread all SVG props (like x, y, width, height) to the underlying SVG element.
const SagittariusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Sagittarius</title>
    <path
      d="M19.4621 3.80861C19.4377 3.74964 19.4015 3.69439 19.3536 3.64645L19 3.5H11C10.7239 3.5 10.5 3.72386 10.5 4C10.5 4.27614 10.7239 4.5 11 4.5H17.7929L8.5 13.7929L5.35355 10.6464C5.15829 10.4512 4.84171 10.4512 4.64645 10.6464C4.45118 10.8417 4.45118 11.1583 4.64645 11.3536L7.79289 14.5L2.64645 19.6464C2.45118 19.8417 2.45118 20.1583 2.64645 20.3536C2.84171 20.5488 3.15829 20.5488 3.35355 20.3536L8.5 15.2071L11.6464 18.3536C11.8417 18.5488 12.1583 18.548 12.3536 18.3536C12.5488 18.1583 12.5488 17.8417 12.3536 17.6464L9.20711 14.5L18.5 5.20711V11.5C18.5 11.7761 18.7239 12 19 12C19.2761 12 19.5 11.7761 19.5 11.5V4C19.5 3.93221 19.4865 3.86756 19.4621 3.80861Z"
      fill="currentColor"
    />
  </svg>
);

export default SagittariusIcon;
